import React, { useEffect, useState } from 'react'
import { Table, Row, Col, Pagination, Tooltip } from 'antd';
import dashboardService from '../../../services/dashbord-service';
import { GiHomeGarage } from 'react-icons/gi';
import dayjs from 'dayjs';
import { EyeOutlined } from "@ant-design/icons";
import { Link } from 'react-router-dom';

function VehicleYard() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, total: 0, pageSize: 10 });
  const [selectedDays, setSelectedDays] = useState(null);

  const filters = [5, 10, 15, 20, 25]

  const columns = [
    {
      title: "S.no",
      dataIndex: 'id',
      key: 'id',
      render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Status",
      dataIndex: 'car_status',
      key: 'car_status',
    },
    {
      title: "Product",
      dataIndex: 'product',
      key: 'product',
      render: (text) => text == null ? "-" : text
    },
    {
      title: "Vehicle",
      dataIndex: 'vehicle',
      key: 'vehicle',
    },
    {
      title: "Vin Number",
      dataIndex: 'chasis_no',
      key: 'chasis_no',
    },
    {
      title: "Receiving Date",
      dataIndex: 'date_rcd',
      key: 'date_rcd',
      render: (text) =>
        dayjs(text).isValid() ? dayjs(text).format("DD MMM YYYY") : "-"
    },
    {
      title: "Days at Yard",
      dataIndex: 'days_at_yard',
      key: 'days_at_yard',
    },
    {
      title: "Customer",
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      render: (text, record, { _id }) => (
        <Link to={`/vehicle/${record.id}`} className="hover:text-primary">
          <Tooltip title="View">
            {/* <Button type="primary" size="small"> */}
            <EyeOutlined />
            {/* </Button> */}
          </Tooltip>
        </Link>
      ),
    },
  ];

  const loadDashbord = async (page = 1, pageSize = pagination.pageSize, days = selectedDays) => {
    setLoading(true)
    const { success, data } = await dashboardService.vehicleYard(page, days)
    setLoading(false)
    if (success) {
      setData(data.data)
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  }
  const handleFilter = (days) => {
    setSelectedDays(days);
  };

  useEffect(() => {
    console.log("VehicleYard component loaded");
    loadDashbord(1, pagination.pageSize, selectedDays);
  }, [selectedDays]);


  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: "#FFFFFF" }}>

      <div className='flex gap-2 items-center'>
        <span className='bg-[#EFF6FF] rounded-md p-2'>
          <GiHomeGarage className='!text-base' style={{ color: '#155DFC' }} />
        </span>
        <h1 style={{ fontWeight: "bold", padding: 0, margin: 0 }}>Vehicles Received at Yard (without title) </h1>
      </div>

      <div className="flex gap-3 py-3">
        {filters.map((day) => (
          <div
            key={day}
            onClick={() => handleFilter(day)}
            className={`border p-2 text-[10px] rounded-3xl cursor-pointer transition
        ${selectedDays === day
                ? "bg-primary text-white border-primary"
                : "hover:bg-primary hover:text-white"
              }`}
          >
            {day}+ days
          </div>
        ))}

        <div
          onClick={() => {
            setSelectedDays(null);
            loadDashbord(1, pagination.pageSize, null);
          }}
          className={`border p-2 text-[10px] rounded-3xl cursor-pointer transition
      ${selectedDays === null
              ? "bg-primary text-white border-primary"
              : "bg-[#F3F4F6]"
            }`}
        >
          Reset
        </div>
      </div>


      <Table columns={columns} scroll={{ x: "max-content" }} dataSource={data}
        loading={loading}
        rowKey="id"
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => loadDashbord(page, pagination.pageSize, selectedDays),
        //   showSizeChanger: false,
        // }}
        pagination={false}
        style={{ marginTop: '10px' }}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => loadDashbord(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />

    </div>
  )
}
export default VehicleYard
